import { destacadoReady, destacadoCleared, destacadoStatus } from './../store/destacado/destacado.selectors';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Contenido } from 'src/common/contenido';
import { Observable, Subscription, BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { Store, select } from '@ngrx/store';
import { allDestacado } from '../store/destacado/destacado.selectors';
import { filter, tap } from 'rxjs/operators';
import { DestacadoPageRequested } from '../store/destacado/destacado.actions';

@Component({
  selector: 'destacado',
  templateUrl: './destacado.component.html',
  styleUrls: ['./destacado.component.scss']
})
export class DestacadoComponent implements OnInit, OnDestroy {

	private readonly NUEVOS_DESTACADOS_TIMEOUT_IN_MILLIS: number = 15000;

	private nuevosDestacadosSubscription: Subscription;
	private nuevosDestacadosSubject: Subject<boolean> = new BehaviorSubject<boolean>( false );
	private destacado$: Observable<Contenido[]>;
	public ready$: Observable<boolean>;
	public nuevosDestacados$: Observable<boolean> = this.nuevosDestacadosSubject.asObservable();

	constructor( private store: Store<AppState> ) {
	}

	ngOnInit(): void {
		this.destacado$ = this.store.select( allDestacado );
		this.ready$ = this.store.select( destacadoReady );

		this.store.dispatch( new DestacadoPageRequested() );

		this.nuevosDestacadosSubscription = combineLatest( [ this.store.select( destacadoCleared ), this.store.select( destacadoStatus ), this.store.select( destacadoReady ) ] ).pipe(
			filter( ([ cleared, status, ready ]) => cleared && ready && status.qty > 0 ),
			tap( () => {
				this.nuevosDestacadosSubject.next( true );
				setTimeout( () => this.nuevosDestacadosSubject.next( false ), this.NUEVOS_DESTACADOS_TIMEOUT_IN_MILLIS );
			})
		).subscribe();
	}

	ngOnDestroy(): void {
		this.nuevosDestacadosSubscription.unsubscribe();
	}

	getCarouselStyle( contenido: Contenido ) {
		return { 'background-image': 'url(' + contenido.imagen + ')' };
	}

}
